import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaExclamationCircle } from 'react-icons/fa';
import ButtonMain from '../../../../Atoms/ButtonMain';
import ButtonSecondary from '../../../../Atoms/ButtonSecondary';
import './styles.css';

export default function TooMuchIdeasModal({ 
    show, 
    onHide,
    selectedCount,
    onReviewSelection,
    onSaveOnly
}) {
    const handleClose = () => {
        onHide();
    };

    return (
        <Modal 
            show={show} 
            onHide={handleClose}
            centered
            backdrop="static"
            className="too-much-ideas-modal"
        >
            <Modal.Header closeButton className="too-much-ideas-modal-header">
            </Modal.Header>
            
            <Modal.Body className="too-much-ideas-modal-body">
                <div className="too-much-ideas-modal-icon">
                    <FaExclamationCircle size={48} />
                </div>
                
                <h2 className="too-much-ideas-modal-title">
                    Você selecionou {selectedCount} ideias
                </h2>
                
                <p className="too-much-ideas-modal-text">
                    Para gerar conceitos detalhados, o limite é de 20 ideias.
                </p>
                
                <p className="too-much-ideas-modal-question">
                    Deseja seguir sem gerar conceitos?
                </p>
            </Modal.Body>
            
            <Modal.Footer className="too-much-ideas-modal-footer">
                <ButtonSecondary onClick={onReviewSelection}>
                    Rever seleção
                </ButtonSecondary>
                
                <ButtonMain onClick={onSaveOnly}>
                    Somente salvar as ideias
                </ButtonMain>
            </Modal.Footer>
        </Modal>
    );
}

